import GrandPrize from './GrandPrize';

export default GrandPrize;
